import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ViewSadhanaHeaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-view-sadhana-header',
  templateUrl: 'view-sadhana-header.html',
})
export class ViewSadhanaHeaderPage {
  myDate:any  = new Date().toISOString();
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewSadhanaHeaderPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-sadhana-header/view-sadhana-header.ts